module.exports = __webpack_public_path__ + "static/img-tax-airplane-lady-38fd93e6fbd86528540025197d45e628.png";